export default __webpack_public_path__ + "static/SupremeLL-Light-b463a762cf764efbf87c30c87352688b.woff";